import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Elegant boutique-hotel booking widget.
 * Collects check-in, check-out, and guests, then navigates to /stay#enquire
 * with query params so the Stay page's enquiry form is pre-populated.
 */
export const BookingWidget = ({ dark = false }) => {
  const nav = useNavigate();
  const today = new Date().toISOString().slice(0, 10);
  const [ci, setCi] = useState("");
  const [co, setCo] = useState("");
  const [g, setG]   = useState("2");

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (ci) params.set("ci", ci);
    if (co) params.set("co", co);
    if (g)  params.set("g", g);
    nav(`/stay?${params.toString()}#enquire`);
  };

  const labelCls = dark
    ? "text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]"
    : "text-[10px] uppercase tracking-[0.28em] text-gold";
  const fieldCls = dark
    ? "w-full bg-transparent border-b border-[#D4AF37]/30 pb-2.5 pt-1.5 text-[14px] text-[#F8F6F2] focus:outline-none focus:border-[#D4AF37] transition-colors"
    : "w-full bg-transparent border-b border-ink/20 pb-2.5 pt-1.5 text-[14px] text-ink focus:outline-none focus:border-gold transition-colors";
  const wrapCls = dark
    ? "bg-[#0F0F0F] text-[#F8F6F2] border border-[#D4AF37]/25"
    : "bg-surface border border-kc";

  return (
    <form
      onSubmit={submit}
      className={`${wrapCls} px-6 md:px-10 py-8 md:py-8 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-end shadow-[0_30px_80px_-40px_rgba(11,11,12,0.35)]`}
      data-testid="booking-widget"
    >
      <div className="md:col-span-3">
        <div className={labelCls}>Check-in</div>
        <input type="date" min={today} value={ci} onChange={(e) => setCi(e.target.value)} className={fieldCls} data-testid="booking-checkin" />
      </div>
      <div className="md:col-span-3">
        <div className={labelCls}>Check-out</div>
        <input type="date" min={ci || today} value={co} onChange={(e) => setCo(e.target.value)} className={fieldCls} data-testid="booking-checkout" />
      </div>
      <div className="md:col-span-3">
        <div className={labelCls}>Guests</div>
        <select value={g} onChange={(e) => setG(e.target.value)} className={fieldCls} data-testid="booking-guests">
          {["1", "2", "3", "4", "5", "6", "7", "8"].map((n) => (
            <option key={n} value={n}>{n} {n === "1" ? "Guest" : "Guests"}</option>
          ))}
        </select>
      </div>
      <div className="md:col-span-3">
        <button type="submit" className={`w-full ${dark ? "btn-gold" : "btn-saffron"} justify-center`} data-testid="booking-submit">
          Check Availability <ArrowUpRight size={14} />
        </button>
      </div>
    </form>
  );
};
